import avatar from '../assets/images/jones/jones.jpg';
import audio from '../assets/sounds/jones.ogg';

import jones01 from '../assets/images/jones/ChristineJones-1.jpg';
import jones02 from '../assets/images/jones/ChristineJones-2.jpg';
import jones03 from '../assets/images/jones/ChristineJones-3.jpg';
import jones04 from '../assets/images/jones/ChristineJones-4.jpg';
import jones05 from '../assets/images/jones/ChristineJones-5.jpg';
import jones06 from '../assets/images/jones/ChristineJones-6.jpg';
import jones07 from '../assets/images/jones/ChristineJones-7.jpg';
import jones08 from '../assets/images/jones/ChristineJones-8.jpg';
import jones09 from '../assets/images/jones/ChristineJones-9.jpg';
import jones10 from '../assets/images/jones/ChristineJones-10.jpg';
import jones11 from '../assets/images/jones/Jones_01.jpg';
import jones12 from '../assets/images/jones/Jones_02.jpg';
import jones13 from '../assets/images/jones/Jones_03.jpg';
import jones14 from '../assets/images/jones/Jones_04.jpg';
import jones15 from '../assets/images/jones/Jones_05.jpg';

const jonesData = {
    avatar,
    audio,
    jones01,
    jones02,
    jones03,
    jones04,
    jones05,
    jones06,
    jones07,
    jones08,
    jones09,
    jones10,
    jones11,
    jones12,
    jones13,
    jones14,
    jones15
}

export default jonesData